import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

const StyledIcon = styled.svg`
  display: inline-block;
  width: 1em;
  height: 1em;
  padding: 0;
  ${({ type, theme, rootContainer, color, invert }: any) =>
    type === 'fill'
      ? css`
          stroke: none;
          fill: ${themeUtilities.getColor(theme, rootContainer, color)};
        `
      : css`
          fill: none;
          stroke: ${invert
            ? themeUtilities.getColor(theme, rootContainer, color, 'container')
            : themeUtilities.getColor(theme, rootContainer, color)};
        `}
`

const Icons = {
  new: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 30 18">
      <title>{t('Icon.new')}</title>
      <path d="M0 .1V18h.5L15 14.1 29.5 18h.5V.1z" />
    </svg>
  ),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  assign: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 17 16">
      <path d="M8 5.041V.413L16.268 7.5 8 14.587v-4.579l-.152.006c-3.093.133-5.378 1.248-6.923 3.749L0 15.26V13.5l.003-.314c.11-5.38 3.049-7.875 7.679-8.13L8 5.04zm1-2.455v3.447l-.763.002c-3.917.07-6.47 1.715-7.09 5.516l-.045.31.118-.13C3.022 9.814 5.458 9 8.5 9H9v3.413L14.732 7.5 9 2.586z" />
    </svg>
  ),
  members: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 64 64">
      <title>{t('Icon.members')}</title>
      <rect data-element="frame" x="0" y="0" width="64" height="64" rx="3" ry="3" stroke="none" />
      <g
        className="nc-icon-wrapper"
        transform="translate(12.8 12.8) scale(0.6)"
        strokeLinecap="square"
        strokeLinejoin="miter"
        strokeWidth="1"
      >
        <path
          data-cap="butt"
          data-color="color-2"
          fill="none"
          strokeMiterlimit="10"
          d="M21.427,27.439 C20.464,25.41,18.395,24,16,24H8c-3.314,0-6,2.686-6,6v8l4,2l1,14h11"
          strokeLinecap="butt"
        />
        <circle data-color="color-2" fill="none" strokeMiterlimit="10" cx="12" cy="12" r="6" />
        <path
          data-cap="butt"
          data-color="color-2"
          fill="none"
          strokeMiterlimit="10"
          d="M42.573,27.439 C43.536,25.41,45.605,24,48,24h8c3.314,0,6,2.686,6,6v8l-4,2l-1,14H46"
          strokeLinecap="butt"
        />
        <circle data-color="color-2" fill="none" strokeMiterlimit="10" cx="52" cy="12" r="6" />
        <path
          fill="none"
          strokeMiterlimit="10"
          d="M38,62H26l-1-16l-5-1V32 c0-4.418,3.582-8,8-8h8c4.418,0,8,3.582,8,8v13l-5,1L38,62z"
        />
        <circle fill="none" strokeMiterlimit="10" cx="32" cy="10" r="8" />
      </g>
    </svg>
  ),
  profile: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 32 32">
      <title>{t('Icon.profile')}</title>
      <path d="M19,19h-6C7.486,19,3,23.486,3,29v0.65l0.594,0.264C3.786,29.999,8.375,32,16,32 s12.214-2.001,12.406-2.086L29,29.65V29C29,23.486,24.514,19,19,19z"></path>
      <path d="M16,17c4.579,0,8-4.751,8-9c0-4.411-3.589-8-8-8S8,3.589,8,8C8,12.249,11.421,17,16,17z"></path>
    </svg>
  ),
  search: ({ className, t }: any) => (
    <svg className={className} version="1.1" viewBox="0 0 15 15">
      <title>{t('Icon.search')}</title>
      <g strokeWidth={2} fill="none">
        <path d="M11.29 11.71l-4-4" />
        <circle cx={5} cy={5} r={4} />
      </g>
    </svg>
  ),
  sandwich: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 12 12">
      <title>{t('Icon.menu')}</title>
      <line x1="0.5" y1="10.5" x2="11.5" y2="10.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="0.5" y1="1.5" x2="11.5" y2="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="0.5" y1="6" x2="5.5" y2="6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  add: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 16 16" width="16" height="16">
      <title>{t('Icon.add')}</title>
      <rect data-element="frame" x="0" y="0" width="16" fill="none" height="16" rx="1" ry="1" />
      <g className="nc-icon-wrapper" transform="translate(3.2 3.2) scale(0.6)">
        <path d="M15,7H9V1c0-0.6-0.4-1-1-1S7,0.4,7,1v6H1C0.4,7,0,7.4,0,8s0.4,1,1,1h6v6c0,0.6,0.4,1,1,1s1-0.4,1-1V9h6 c0.6,0,1-0.4,1-1S15.6,7,15,7z" />
      </g>
    </svg>
  ),
  addDueDate: ({ className, t }: any) => (
    <svg className={className} width="15px" height="15px" viewBox="0 0 15 15">
      <title>{t('Icon.addDueDate')}</title>
      <defs>
        <filter id="filter-1">
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="0 0 0 0 0.400000 0 0 0 0 0.400000 0 0 0 0 0.400000 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g
        id="icons/-add-due-date"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Schedule-Icon">
          <g>
            <line x1="0" y1="5" x2="15" y2="5" id="Path" stroke="#111111" />
            <path
              d="M15,5 L15,3 C15,2.44771525 14.5522847,2 14,2 L1,2 C0.44771525,2 0,2.44771525 0,3 L0,14 C0,14.5522847 0.44771525,15 1,15 L6,15"
              id="Path"
              stroke="#111111"
            />
            <line x1="4" y1="0" x2="4" y2="2" id="Path" stroke="#111111" />
            <line x1="11" y1="0" x2="11" y2="2" id="Path" stroke="#111111" />
            <circle id="Oval" stroke="#111111" cx="11" cy="11" r="4" />
            <line x1="11" y1="9" x2="11" y2="13" id="Path" stroke="#111111" />
            <line x1="9" y1="11" x2="13" y2="11" id="Path" stroke="#111111" />
          </g>
        </g>
      </g>
    </svg>
  ),
  delete: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 32 32">
      <title>{t('Icon.delete')}</title>
      <g strokeLinecap="square" strokeLinejoin="miter" strokeWidth="2">
        <path d="M27,10V28a3,3,0,0,1-3,3H8a3,3,0,0,1-3-3V10" fill="none" strokeMiterlimit="10" />
        <line x1="16" y1="15" x2="16" y2="25" fill="none" strokeMiterlimit="10" />
        <line x1="11" y1="15" x2="11" y2="25" fill="none" strokeMiterlimit="10" />
        <line x1="21" y1="15" x2="21" y2="25" fill="none" strokeMiterlimit="10" />
        <polyline
          data-cap="butt"
          data-color="color-2"
          points="11 6 11 1 21 1 21 6"
          fill="none"
          strokeMiterlimit="10"
          strokeLinecap="butt"
        />
        <line data-color="color-2" x1="30" y1="6" x2="2" y2="6" fill="none" strokeMiterlimit="10" />
      </g>
    </svg>
  ),
  dueDateAdded: ({ className, t }: any) => (
    <svg id="dueDateAdded" className={className} width="15px" height="15px" viewBox="0 0 15 15">
      <title>{t('Icon.dueDateAdded')}</title>
      <g
        id="icons/-due-date-added"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Group-3" stroke="#111111">
          <path
            d="M15,8 L15,3 C15,2.448 14.552,2 14,2 L1,2 C0.448,2 0,2.448 0,3 L0,14 C0,14.552 0.448,15 1,15 L7,15"
            id="Path"
          />
          <polyline id="Path" points="9 13 11 15 15 11" />
          <line x1="0" y1="4.5" x2="15" y2="4.5" id="Path" />
          <line x1="3.5" y1="0" x2="3.5" y2="2" id="Path" />
          <line x1="10.5" y1="0" x2="10.5" y2="2" id="Path" />
        </g>
      </g>
    </svg>
  ),
  duplicateTask: ({ className, t }: any) => (
    <svg width="14px" height="16px" viewBox="0 0 14 16" className={className}>
      <title>{t('Icon.duplicate')}</title>
      <defs>
        <filter id="filter-1">
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="0 0 0 0 0.290003 0 0 0 0 0.564387 0 0 0 0 0.895576 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g
        id="icons/-duplicate-task"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="document-copy">
          <g>
            <rect id="Rectangle" x="0.5" y="3.5" width="10" height="12" />
            <polyline id="Path" points="2.5 0.5 13.5 0.5 13.5 13.5" />
            <line x1="3.5" y1="6.5" x2="7.5" y2="6.5" id="Path" />
            <line x1="3.5" y1="9.5" x2="7.5" y2="9.5" id="Path" />
            <line x1="3.5" y1="12.5" x2="7.5" y2="12.5" id="Path" />
          </g>
        </g>
      </g>
    </svg>
  ),
  gift: ({ className, t }: any) => (
    <svg viewBox="0 0 48 48" className={className}>
      <title>{t('Icon.gift')}</title>
      <g strokeLinecap="square" strokeLinejoin="miter" strokeWidth="2" stroke="currentColor">
        <path d="M42,26V41a4,4,0,0,1-4,4H10a4,4,0,0,1-4-4V26" fill="none" stroke="currentColor" strokeMiterlimit="10" />
        <rect x="2" y="12.003" width="44" height="8" fill="none" stroke="currentColor" strokeMiterlimit="10" />
        <polyline data-color="color-2" points="28 12.003 28 45 20 45 20 12.003" fill="none" strokeMiterlimit="10" />
        <path
          data-color="color-2"
          d="M8,7a5.174,5.174,0,0,1,5.334-5C21.222,2,24,12,24,12H13.334A5.175,5.175,0,0,1,8,7Z"
          fill="none"
          strokeMiterlimit="10"
        />
        <path
          data-color="color-2"
          d="M34.666,12H24S26.778,2,34.666,2A5.174,5.174,0,0,1,40,7,5.175,5.175,0,0,1,34.666,12Z"
          fill="none"
          strokeMiterlimit="10"
        />
      </g>
    </svg>
  ),
  notes: ({ className, t }: any) => (
    <svg width="14px" height="16px" viewBox="0 0 14 16" className={className}>
      <title>{t('Icon.notes')}</title>
      <defs>
        <filter id="filter-1">
          <feColorMatrix in="SourceGraphic" type="matrix" />
        </filter>
      </defs>
      <g
        id="icons/-notes"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="notes">
          <g>
            <path
              d="M11.5,1.5 L12.5,1.5 C13.0522847,1.5 13.5,1.94771525 13.5,2.5 L13.5,14.5 C13.5,15.0522847 13.0522847,15.5 12.5,15.5 L1.5,15.5 C0.94771525,15.5 0.5,15.0522847 0.5,14.5 L0.5,2.5 C0.5,1.94771525 0.94771525,1.5 1.5,1.5 L2.5,1.5"
              id="Path"
              stroke="#2A3042"
            />
            <rect id="Rectangle" stroke="#2A3042" x="4.5" y="0.5" width="5" height="2" />
            <line x1="3.5" y1="6.5" x2="10.5" y2="6.5" id="Path" stroke="#2A3042" />
            <line x1="3.5" y1="9.5" x2="10.5" y2="9.5" id="Path" stroke="#2A3042" />
            <line x1="3.5" y1="12.5" x2="10.5" y2="12.5" id="Path" stroke="#2A3042" />
          </g>
        </g>
      </g>
    </svg>
  ),
  noPriority: ({ className, t }: any) => (
    <svg width="16px" height="16px" viewBox="0 0 16 16" className={className}>
      <title>{t('Icon.noPriority')}</title>
      <defs>
        <filter id="filter-1">
          <feColorMatrix in="SourceGraphic" type="matrix" />
        </filter>
      </defs>
      <g
        id="icons/-priority/-no-priority"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="priority-normal">
          <g>
            <path
              d="M5.51452601,2.51466667 L10.4851927,2.51466667 C12.1420469,2.51466667 13.4851927,3.85781242 13.4851927,5.51466667 L13.4851927,10.4853333 C13.4851927,12.1421876 12.1420469,13.4853333 10.4851927,13.4853333 L5.51452601,13.4853333 C3.85767176,13.4853333 2.51452601,12.1421876 2.51452601,10.4853333 L2.51452601,5.51466667 C2.51452601,3.85781242 3.85767176,2.51466667 5.51452601,2.51466667 Z"
              id="Rectangle"
              stroke="#111111"
              transform="translate(7.999859, 8.000000) rotate(-45.000000) translate(-7.999859, -8.000000) "
            />
            <line x1="5.57575758" y1="6.54545455" x2="10.4242424" y2="6.54545455" id="Path" stroke="#111111" />
            <line x1="5.57575758" y1="9.45454545" x2="10.4242424" y2="9.45454545" id="Path" stroke="#111111" />
          </g>
        </g>
      </g>
    </svg>
  ),
  calendar: ({ className, t }: any) => (
    <svg className={className} width="16px" height="19px" viewBox="0 0 16 19">
      <title>{t('Icon.calendar')}</title>
      <g id="Task-Comments" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Mobile/-Comments/-Detail-Screen-Read-Comments"
          transform="translate(-269.000000, -360.000000)"
          fill="#111111"
          fillRule="nonzero"
        >
          <g id="Due-Date" transform="translate(12.000000, 326.000000)">
            <g id="Due-Date-Pills" transform="translate(23.500000, 29.499341)">
              <g id="Tomorrow-Copy" transform="translate(226.000000, 0.500659)">
                <g id="calendar-date" transform="translate(8.000000, 5.499341)">
                  <path
                    d="M14,2 L11.5,2 L11.5,0.5 C11.5,0.223857625 11.2761424,0 11,0 C10.7238576,0 10.5,0.223857625 10.5,0.5 L10.5,2 L4.5,2 L4.5,0.5 C4.5,0.223857625 4.27614237,0 4,0 C3.72385763,0 3.5,0.223857625 3.5,0.5 L3.5,2 L1,2 C0.44771525,2 0,2.44771525 0,3 L0,14.5 C0,15.0522847 0.44771525,15.5 1,15.5 L14,15.5 C14.5522847,15.5 15,15.0522847 15,14.5 L15,3 C15,2.44771525 14.5522847,2 14,2 Z M13.5,14.5 L1.5,14.5 C1.22385763,14.5 1,14.2761424 1,14 L1,5 C1,4.72385763 1.22385763,4.5 1.5,4.5 L13.5,4.5 C13.7761424,4.5 14,4.72385763 14,5 L14,14 C14,14.2761424 13.7761424,14.5 13.5,14.5 Z"
                    id="Shape"
                  />
                  <rect id="Rectangle" x="2" y="10" width="3" height="2.5" />
                  <rect id="Rectangle" x="2" y="6.5" width="3" height="2.5" />
                  <rect id="Rectangle" x="6" y="10" width="3" height="2.5" />
                  <rect id="Rectangle" x="6" y="6.5" width="3" height="2.5" />
                  <rect id="Rectangle" x="10" y="6.5" width="3" height="2.5" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  overdue: ({ className, t }: any) => (
    <svg className={className} width="15px" height="15px" viewBox="0 0 15 15" version="1.1">
      <title>{t('Icon.overdue')}</title>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Due-Date/-Past-Due" transform="translate(0.000000, -2.000000)" fill="#F53F41" fillRule="nonzero">
          <path
            d="M7.18945312,2.10546875 C11.0039062,2.10546875 14.1689453,5.26367188 14.1689453,9.078125 C14.1689453,12.8857422 11.0107422,16.0507812 7.19628906,16.0507812 C3.38867188,16.0507812 0.223632812,12.8857422 0.223632812,9.078125 C0.223632812,5.26367188 3.38183594,2.10546875 7.18945312,2.10546875 Z M8.44042969,5.13378906 C8.50878906,4.73730469 8.08496094,4.55273437 7.82519531,4.87402344 L7.82519531,4.87402344 L4.18847656,9.50195312 C3.89453125,9.86425781 4.02441406,10.1650391 4.40039062,10.1650391 L4.40039062,10.1650391 L6.24609375,10.1650391 L5.7265625,13.0087891 C5.65820312,13.4052734 6.07519531,13.5898437 6.33496094,13.2617187 L6.33496094,13.2617187 L9.97851562,8.63378906 C10.2724609,8.27148437 10.1425781,7.97753906 9.76660156,7.97753906 L9.76660156,7.97753906 L7.9140625,7.97753906 Z"
            id="Combined-Shape"
          />
        </g>
      </g>
    </svg>
  ),
  close: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 24 24">
      <title>{t('Icon.close')}</title>
      <path d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M16.7,15.3c0.4,0.4,0.4,1,0,1.4 C16.5,16.9,16.3,17,16,17s-0.5-0.1-0.7-0.3L12,13.4l-3.3,3.3C8.5,16.9,8.3,17,8,17s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l3.3-3.3 L7.3,8.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3.3,3.3l3.3-3.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L13.4,12L16.7,15.3z" />
    </svg>
  ),
  clear: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 12 12">
      <title>{t('Icon.clear')}</title>
      <circle cx="6" cy="6" r="5.5" fill="none" />
      <line x1="4" y1="4" x2="8" y2="8" fill="none" />
      <line x1="8" y1="4" x2="4" y2="8" fill="none" />
    </svg>
  ),
  chevronUp: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 16 16">
      <title>{t('Icon.chevronUp')}</title>
      <path d="M14,11.414l-6-6-6,6L.586,10,7.293,3.293a1,1,0,0,1,1.414,0L15.414,10Z" />
    </svg>
  ),
  doubleChevronUp: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 16 16">
      <title>{t('Icon.doubleChevronUp')}</title>
      <path d="M14,9.414l-6-6-6,6L.586,8,7.293,1.293a1,1,0,0,1,1.414,0L15.414,8Z" />
      <path d="M14,15.414l-6-6-6,6L.586,14,7.293,7.293a1,1,0,0,1,1.414,0L15.414,14Z" />
    </svg>
  ),
  chevronDown: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 16 16">
      <title>{t('Icon.chevronDown')}</title>
      <g>
        <path d="M14,4.586l-6,6-6-6L.586,6l6.707,6.707a1,1,0,0,0,1.414,0L15.414,6Z" />
      </g>
    </svg>
  ),
  chevronLeft: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 12 12">
      <title>{t('Icon.chevronDown')}</title>
      <g>
        <path d="M8.707.293a1,1,0,0,0-1.414,0l-5,5a1,1,0,0,0,0,1.414l5,5a1,1,0,0,0,1.414-1.414L4.414,6,8.707,1.707A1,1,0,0,0,8.707.293Z" />
      </g>
    </svg>
  ),
  chevronRight: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 18 18">
      <title>{t('Icon.chevronRight')}</title>
      <g>
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
      </g>
    </svg>
  ),
  arrowDown: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 12 12">
      <title>{t('Icon.chevronDown')}</title>
      <g>
        <path d="M11.5,2H.5a.5.5,0,0,0-.412.783l5.5,8a.5.5,0,0,0,.824,0l5.5-8A.5.5,0,0,0,11.5,2Z" />
      </g>
    </svg>
  ),
  edit: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 12 12">
      <title>{t('Icon.edit')}</title>
      <g className="nc-icon-wrapper">
        <polygon points="9.5 0.5 11.5 2.5 4.5 9.5 1.5 10.5 2.5 7.5 9.5 0.5" />
      </g>
    </svg>
  ),

  // TODO Remove height and width from icons in this file that use it
  closeFilled: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 16 16" width="16" height="16">
      <title>{t('Icon.close')}</title>
      <g className="nc-icon-wrapper">
        <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M11.5,10.1l-1.4,1.4L8,9.4l-2.1,2.1l-1.4-1.4L6.6,8 L4.5,5.9l1.4-1.4L8,6.6l2.1-2.1l1.4,1.4L9.4,8L11.5,10.1z" />
      </g>
    </svg>
  ),
  warning: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 32 32">
      <title>{t('Icon.warning')}</title>
      <g>
        <path d="M30.88,29.526l-14-26c-0.349-0.647-1.412-0.647-1.761,0l-14,26c-0.167,0.31-0.159,0.685,0.022,0.987 C1.322,30.815,1.648,31,2,31h28c0.352,0,0.678-0.185,0.858-0.487C31.039,30.21,31.047,29.836,30.88,29.526z M17.714,12L17,22h-2 l-0.714-10H17.714z M16,28c-0.982,0-1.778-0.796-1.778-1.778c0-0.982,0.796-1.778,1.778-1.778s1.778,0.796,1.778,1.778 C17.778,27.204,16.982,28,16,28z" />
      </g>
    </svg>
  ),
  comment: ({ className, t }: any) => (
    <svg className={className} width="12px" height="12px" viewBox="0 0 12 12">
      <title>{t('Icon.comment')}</title>
      <g
        id="icons/-comments"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Icon/-Utility/-Chat/-12" transform="translate(-5.000000, -5.000000)" stroke="#707070">
          <g id="Unread-Comments" transform="translate(5.000000, 5.000000)">
            <path
              d="M11.5,5.267 C11.5,2.634 9.037,0.5 6,0.5 C2.963,0.5 0.5,2.634 0.5,5.267 C0.5,7.9 2.963,10.033 6,10.033 C6.37655439,10.0329507 6.75236163,9.99948614 7.123,9.933 L10,11.5 L10,8.5 C10.9279678,7.67791789 11.4715079,6.50640767 11.5,5.267 L11.5,5.267 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  leave: ({ className, t }: any) => (
    <svg className={className} width="16px" height="18px" viewBox="0 0 16 18">
      <title>{t('Icon.leave')}</title>
      <g fill="none" fillRule="evenodd">
        <path d="M15.273 0H6.545v1.455h8V16h-8v1.455h8.728a.727.727 0 00.727-.728v-16A.727.727 0 0015.273 0z" />
        <path d="M0 8.727l5.09-4.363V8h6.546v1.455H5.091v3.636z" />
      </g>
    </svg>
  ),
  checkAll: ({ className, t }: any) => (
    <svg className={className} width={46} height={36} viewBox="0 0 46 36">
      <title>{t('Icon.checkAll')}</title>
      <g>
        <path d="M10.631 32.841L0 22l3-3 8 5L34 0l3 2-23.35 30.653a2 2 0 01-3.019.188z" fill="#37D88A" />
        <path
          d="M45 9h-5a1 1 0 010-2h5a1 1 0 010 2zM45 18H33a1 1 0 010-2h12a1 1 0 010 2zM45 27H26a1 1 0 010-2h19a1 1 0 010 2zM45 36H19a1 1 0 010-2h26a1 1 0 010 2z"
          fill="#B3B3B3"
        />
      </g>
    </svg>
  ),
  list: ({ className, t }: any) => (
    <svg className={className} width={16} height={14} viewBox="0 0 16 14">
      <title>{t('Icon.list')}</title>
      <defs>
        <style>{'.prefix__a{fill:none;stroke:#111;stroke-linecap:round;stroke-linejoin:round}'}</style>
      </defs>
      <g transform="translate(0 -1)">
        <path className="prefix__a" d="M6.5 3.5h9M6.5 8.5h9M6.5 13.5h9" />
        <circle className="prefix__a" cx={1.5} cy={1.5} r={1.5} transform="translate(.5 1.5)" />
        <circle className="prefix__a" cx={1.5} cy={1.5} r={1.5} transform="translate(.5 6.5)" />
        <circle className="prefix__a" cx={1.5} cy={1.5} r={1.5} transform="translate(.5 11.5)" />
      </g>
    </svg>
  ),
  checkmark: ({ className, t }: any) => (
    <svg className={className} width={16} height={12.8} viewBox="0 0 16 12.8">
      <title>{t('Icon.checkmark')}</title>
      <path d="M5.6 8L2.4 4.8 0 7.2l5.6 5.6L16 2.4 13.6 0z" fill="#0248d5" />
    </svg>
  ),
  ellipsis: ({ className }: any) => (
    <svg className={className} width={24} height={14} viewBox="0 0 24 14">
      <path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
    </svg>
  ),
  person: ({ className }: any) => (
    <svg className={className} viewBox="0 0 22 22">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g transform="translate(5.000000, 5.000000)" stroke="#707070">
          <path
            d="M8.5,3 C8.5,4.381 7.381,6.5 6,6.5 C4.619,6.5 3.5,4.381 3.5,3 C3.5,1.61928813 4.61928813,0.5 6,0.5 C7.38071187,0.5 8.5,1.61928813 8.5,3 Z"
            id="Path"
          ></path>
          <path
            d="M2.227,7 C1.42033734,7.76109456 0.862607916,8.74827564 0.627,9.832 C3.86380578,12.0559476 8.13619422,12.0559476 11.373,9.832 C11.1373921,8.74827564 10.5796627,7.76109456 9.773,7"
            id="Path"
          ></path>
        </g>
      </g>
    </svg>
  ),
  today: ({ className }: any) => (
    <svg className={className} viewBox="0 0 22 22">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g transform="translate(5.000000, 5.000000)" stroke="#707070">
          <line x1="6" y1="0.5" x2="6" y2="1.5" id="Path"></line>
          <line x1="9.889" y1="2.111" x2="9.182" y2="2.818" id="Path"></line>
          <line x1="11.5" y1="6" x2="10.5" y2="6" id="Path"></line>
          <line x1="9.889" y1="9.889" x2="9.182" y2="9.182" id="Path"></line>
          <line x1="6" y1="11.5" x2="6" y2="10.5" id="Path"></line>
          <line x1="2.111" y1="9.889" x2="2.818" y2="9.182" id="Path"></line>
          <line x1="0.5" y1="6" x2="1.5" y2="6" id="Path"></line>
          <line x1="2.111" y1="2.111" x2="2.818" y2="2.818" id="Path"></line>
          <circle id="Oval" cx="6" cy="6" r="2.5"></circle>
        </g>
      </g>
    </svg>
  ),
  week: ({ className }: any) => (
    <svg className={className} viewBox="0 0 22 22">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g transform="translate(5.000000, 4.000000)" stroke="#707070">
          <line x1="2.5" y1="0.5" x2="2.5" y2="2.5" id="Path"></line>
          <line x1="9.5" y1="0.5" x2="9.5" y2="2.5" id="Path"></line>
          <line x1="0.5" y1="5.5" x2="11.5" y2="5.5" id="Path"></line>
          <rect id="Rectangle" x="0.5" y="2.5" width="11" height="9" rx="1"></rect>
        </g>
      </g>
    </svg>
  ),
  upload: ({ className, t }: any) => (
    <svg className={className} viewBox="0 0 32 32">
      <title>{t('Icon.upload')}</title>
      <g strokeLinecap="square" strokeLinejoin="miter" strokeWidth="2">
        <line fill="none" strokeMiterlimit="10" x1="16" y1="30" x2="16" y2="14" strokeLinecap="butt"></line>
        <polyline fill="none" strokeMiterlimit="10" points="11,19 16,14 21,19 "></polyline>
        <path
          fill="none"
          strokeMiterlimit="10"
          d="M20,23h6 c2.8-0.3,5-2.6,5-5.5c0-2.9-2.2-5.2-5-5.5C25.5,7,21.2,3,16,3c-4.5,0-8.3,3-9.6,7.1C3.4,10.6,1,13.3,1,16.5c0,3.4,2.6,6.2,6,6.5h5"
        ></path>
      </g>
    </svg>
  ),
  allDone: ({ className }: any) => (
    <svg className={className} viewBox="0 0 163 184">
      <title>todo</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-191.000000, -176.000000)" fillRule="nonzero">
          <g transform="translate(272.406970, 267.885118) rotate(12.000000) translate(-272.406970, -267.885118) translate(206.906970, 188.385118)">
            <path
              d="M124.011394,7.62050209 L7.69560443,7.62050209 C3.91534127,7.62050209 0.853499163,10.6919794 0.853499163,14.4841385 L0.853499163,151.756866 C0.853499163,155.549025 3.91534127,158.620502 7.69560443,158.620502 L124.011394,158.620502 C127.791657,158.620502 130.853499,155.549025 130.853499,151.756866 L130.853499,14.4841385 C130.853499,10.6919794 127.791657,7.62050209 124.011394,7.62050209 Z"
              id="Path"
              fill="#BFBFBF"
            ></path>
            <path
              d="M110.241804,140.538399 L22.0275184,140.538399 C20.1546613,140.538399 18.6346613,138.996752 18.6346613,137.097222 L18.6346613,26.9795751 C18.6346613,25.0800457 20.1546613,23.5383986 22.0275184,23.5383986 L110.241804,23.5383986 C112.114661,23.5383986 113.634661,25.0800457 113.634661,26.9795751 L113.634661,137.097222 C113.634661,138.996752 112.114661,140.538399 110.241804,140.538399 Z"
              id="Path"
              fill="#FFFFFF"
            ></path>
            <path
              d="M79.5021436,14.2122478 C79.5021436,6.48074782 73.3455811,0.212247821 65.7521436,0.212247821 C58.1587061,0.212247821 52.0021436,6.48074782 52.0021436,14.2122478 L41.6896436,14.2122478 C39.7921436,14.2122478 38.2521436,15.7802478 38.2521436,17.7122478 L38.2521436,31.7122478 C38.2521436,33.6442478 39.7921436,35.2122478 41.6896436,35.2122478 L89.8146436,35.2122478 C91.7121436,35.2122478 93.2521436,33.6442478 93.2521436,31.7122478 L93.2521436,17.7122478 C93.2521436,15.7802478 91.7121436,14.2122478 89.8146436,14.2122478 L79.5021436,14.2122478 Z"
              id="Path"
              fill="#FFB31A"
            ></path>
            <circle id="Oval" fill="#E09600" cx="66.876792" cy="13.383834" r="3.5"></circle>
            <path
              d="M59.6203363,103.554945 C58.7426533,103.554945 57.8649704,103.211953 57.1964228,102.529471 L43.4826269,88.5298205 C42.1421033,87.1613547 42.1421033,84.94941 43.4826269,83.5809442 C44.8231505,82.2124785 46.9899302,82.2124785 48.3304538,83.5809442 L59.6203363,95.1061561 L84.6240147,69.5812942 C85.9645383,68.2128284 88.131318,68.2128284 89.4718416,69.5812942 C90.8123651,70.94976 90.8123651,73.1617047 89.4718416,74.5301705 L62.0442497,102.529471 C61.3757021,103.211953 60.4980192,103.554945 59.6203363,103.554945 Z"
              id="Path"
              fill="#418D68"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

interface IconProps {
  className?: string
  color?: string
  id?: string
  invert?: boolean
  name?: unknown[]
  rootContainer?: string
  type?: 'stroke' | 'fill'
}

const Icon = ({ className, name, rootContainer, color, type, invert, id }: IconProps) => {
  const { t } = useTranslation('shared')

  // @ts-expect-error
  const TheIcon = Icons[name]
  return (
    <StyledIcon
      id={id}
      as={TheIcon}
      className={className}
      rootContainer={rootContainer}
      color={color}
      type={type}
      invert={invert}
      t={t}
    />
  )
}

Icon.displayName = 'Icon'

Icon.defaultProps = {
  type: 'stroke'
}

export default Icon

const IconNames = Object.keys(Icons)
export { IconNames }
